import { render } from "./ReturnCSV.vue?vue&type=template&id=7086584e&scoped=true"
import script from "./ReturnCSV.vue?vue&type=script&lang=js"
export * from "./ReturnCSV.vue?vue&type=script&lang=js"

import "./ReturnCSV.vue?vue&type=style&index=0&id=7086584e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7086584e"]])

export default __exports__